import React, {Component} from 'react';
import './Wheel.css';

class Wheel extends Component {

  constructor(props) {
    super(props);

    this.handleAnimationEnd = this.handleAnimationEnd.bind(this);
    this.handleAnimationStart = this.handleAnimationStart(this);

    this.state = {
      spinning: false
    }
  }

  handleAnimationEnd() {
    this.setState({spinning: false});
  }

  handleAnimationStart() {
    // this.setState({spinning: true});
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.spinning !== this.state.spinning) {
      this.props.handleSpinning(this.state.spinning);
    }

    if (prevProps.prize !== this.props.prize) {
      this.setState({spinning: true});
    }
  }

  render() {
    const prizeClassName = this.props.prize || '';

    return (
      <div className={"wheel-container" + (this.state.spinning ? ' spinning':'')}>
        <div className={"wheel " + prizeClassName} onAnimationEnd={this.handleAnimationEnd} onAnimationStart={this.handleAnimationStart} />
        <div className="wheel-pointer" />
      </div>
    );
  }
}

export default Wheel;